import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import Home from './pages/Home';
import Header from './components/Header';
import Footer from './components/Footer';

import ContactCenter from './pages/ContactCenter';
import ConsultoriaIntegral from './pages/ConsultoriaIntegral';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className='page-wraper'>
      <Router>
        <Header/>
        <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact-center-soluciones-inteligentes" element={<ContactCenter />} />
              <Route path="/consultoría-integral" element={<ConsultoriaIntegral />} />

              <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
